import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h1" }, "Update Profile", -1)
const _hoisted_2 = {
  class: "container col-sm-6",
  style: {"float":"none"}
}
const _hoisted_3 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-12 fw-bold h4 mb-2" }, "Personal Information")
], -1)
const _hoisted_6 = { class: "row col-12 text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " First Name ", -1)
const _hoisted_8 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_9 = { class: "row col-12 text-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Last Name ", -1)
const _hoisted_11 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_12 = { class: "row col-12 text-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Previously Known As", -1)
const _hoisted_14 = { class: "row col-12 text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Mobile ", -1)
const _hoisted_16 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_17 = { class: "row col-12 text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Email ", -1)
const _hoisted_19 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_20 = { class: "row col-12 text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Phone2 ", -1)
const _hoisted_22 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4 mb-2 fw-bold" }, "Work Information")
], -1)
const _hoisted_25 = { class: "row col-12 text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " SIA No. ", -1)
const _hoisted_27 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_28 = { class: "row col-12 text-left" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " SIA Exp. Date ", -1)
const _hoisted_30 = { class: "col-4" }
const _hoisted_31 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_32 = { class: "row col-12 text-left" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " NI/UTR ", -1)
const _hoisted_34 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_35 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_36 = { class: "container" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Address Information")
], -1)
const _hoisted_38 = { class: "row col-12 text-left" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " House Name/Number", -1)
const _hoisted_40 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_41 = { class: "row col-12 text-left" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Street", -1)
const _hoisted_43 = { class: "row col-12 text-left" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " City ", -1)
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_47 = { class: "row col-12 text-left" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " County ", -1)
const _hoisted_49 = { class: "row col-12 text-left" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " PostCode ", -1)
const _hoisted_51 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_52 = { class: "row col-12 text-left" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Country ", -1)
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_56 = { class: "row col-12 text-left" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Conveyance ", -1)
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_60 = { class: "row col-12 text-left" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Emergency Contact", -1)
const _hoisted_62 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_63 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_64 = { class: "container" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Origin Information")
], -1)
const _hoisted_66 = { class: "row col-12 text-left" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " DateOfBirth ", -1)
const _hoisted_68 = { class: "border border-1 col-8" }
const _hoisted_69 = { class: "col-6" }
const _hoisted_70 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_71 = { class: "row col-12 text-left" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Country Of Birth ", -1)
const _hoisted_73 = ["value"]
const _hoisted_74 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_75 = { class: "row col-12 text-left" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Nationality", -1)
const _hoisted_77 = ["value"]
const _hoisted_78 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_79 = { class: "row col-12 text-left" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Gender", -1)
const _hoisted_81 = ["value"]
const _hoisted_82 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_83 = { class: "row col-12 text-left" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Place Of Birth ", -1)
const _hoisted_85 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_86 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_87 = { class: "container" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Passport Information")
], -1)
const _hoisted_89 = { class: "row col-12 text-left" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Passport No", -1)
const _hoisted_91 = { class: "row col-12 text-left" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Expires On ", -1)
const _hoisted_93 = { class: "border border-1 col-8" }
const _hoisted_94 = { class: "col-6" }
const _hoisted_95 = { class: "row col-12 text-left" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Visa Expires ", -1)
const _hoisted_97 = { class: "border border-1 col-8" }
const _hoisted_98 = { class: "col-6" }
const _hoisted_99 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_100 = { class: "container" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Identity Document Information")
], -1)
const _hoisted_102 = { class: "row col-12 text-left" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " ID Document", -1)
const _hoisted_104 = ["value"]
const _hoisted_105 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_106 = { class: "row col-12 text-left" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Number ", -1)
const _hoisted_108 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_109 = { class: "row col-12 text-left" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Issue Date ", -1)
const _hoisted_111 = { class: "border border-1 col-8" }
const _hoisted_112 = { class: "col-6" }
const _hoisted_113 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_114 = { class: "row col-12 text-left" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Expiry Date ", -1)
const _hoisted_116 = { class: "border border-1 col-8" }
const _hoisted_117 = { class: "col-6" }
const _hoisted_118 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_119 = { class: "row col-12 text-left" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Issued By ", -1)
const _hoisted_121 = ["value"]
const _hoisted_122 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", { class: "col-10" }, [
  /*#__PURE__*/_createTextVNode(" By Submitting this form you agree to our "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://eaglesecurityltd.co.uk/privacy-policy-2",
    target: "blank"
  }, "Privacy Policy")
], -1)
const _hoisted_124 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.FirstName) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.FirstName]
            ]),
            (!$setup.formData.FirstName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.LastName) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.LastName]
            ]),
            (!$setup.formData.LastName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.PreviouslyKnownAs) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PreviouslyKnownAs]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.MobileNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.MobileNumber]
            ]),
            (!$setup.formData.MobileNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.Email) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Email]
            ]),
            (!$setup.formData.Email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.Phone2) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Phone2]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.SiabadageNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.SiabadageNumber]
            ]),
            (!$setup.formData.SiabadageNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, " (" + _toDisplayString($setup.formatDateForDisplay($setup.formData.SiaExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              class: "col-4",
              type: "date",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.SiaExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.SiaExpiryDate]
            ]),
            (!$setup.formData.SiaExpiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.Ninumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Ninumber]
            ]),
            (!$setup.formData.Ninumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formData.HouseNameNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.HouseNameNumber]
            ]),
            (!$setup.formData.HouseNameNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formData.StreetAdress) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.StreetAdress]
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.selectedCityName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityList, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city.cityId,
                  value: city.name
                }, _toDisplayString(city.name), 9, _hoisted_45))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCityName]
            ]),
            (!$setup.selectedCityName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_46, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.formData.County) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.County]
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.formData.PostCode) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PostCode]
            ]),
            (!$setup.formData.PostCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_51, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.selectedAddressCountry) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_54))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedAddressCountry]
            ]),
            (!$setup.selectedAddressCountry)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.selectedConveyanceName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conveyanceListArray, (conveyance) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: conveyance.id,
                  value: conveyance.name
                }, _toDisplayString(conveyance.name), 9, _hoisted_58))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedConveyanceName]
            ]),
            (!$setup.selectedConveyanceName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_59, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.formData.NextOfKin) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.NextOfKin]
            ]),
            (!$setup.formData.NextOfKin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_62, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("span", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.DateOfBirth)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.formData.DateOfBirth) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.DateOfBirth]
              ])
            ]),
            (!$setup.formData.DateOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_70, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.selectedCountryOfBirth) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_73))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCountryOfBirth]
            ]),
            (!$setup.selectedCountryOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_74, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.selectedNationality) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_77))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedNationality]
            ]),
            (!$setup.selectedNationality)
              ? (_openBlock(), _createElementBlock("span", _hoisted_78, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.selectedGenderType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.genderList, (g) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: g.id,
                  value: g.name
                }, _toDisplayString(g.name), 9, _hoisted_81))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedGenderType]
            ]),
            (!$setup.selectedGenderType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_82, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.formData.PlaceOfBirth) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PlaceOfBirth]
            ]),
            (!$setup.formData.PlaceOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_85, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _hoisted_88,
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _withDirectives(_createElementVNode("input", {
              class: "col-6",
              type: "text",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.formData.PassportNo) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PassportNo]
            ])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("span", _hoisted_93, [
              _createElementVNode("span", _hoisted_94, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.PassportExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.formData.PassportExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.PassportExpiryDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("span", _hoisted_97, [
              _createElementVNode("span", _hoisted_98, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.VisaExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.formData.VisaExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.VisaExpiryDate]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _hoisted_101,
          _createElementVNode("div", _hoisted_102, [
            _hoisted_103,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.selectedIdDocumentName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentTypesList, (dt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: dt.id,
                  value: dt.name
                }, _toDisplayString(dt.name), 9, _hoisted_104))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentName]
            ]),
            (!$setup.selectedIdDocumentName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_105, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_106, [
            _hoisted_107,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.idDocumentNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.idDocumentNumber]
            ]),
            (!$setup.idDocumentNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_108, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("span", _hoisted_111, [
              _createElementVNode("span", _hoisted_112, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentIssueDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.idDocumentIssueDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.idDocumentIssueDate]
              ])
            ]),
            (!$setup.idDocumentIssueDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_113, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_114, [
            _hoisted_115,
            _createElementVNode("span", _hoisted_116, [
              _createElementVNode("span", _hoisted_117, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.idDocumentExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.idDocumentExpiryDate]
              ])
            ]),
            (!$setup.idDocumentExpiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_118, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_119, [
            _hoisted_120,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.selectedIdDocumentCountryOfIssue) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_121))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentCountryOfIssue]
            ]),
            (!$setup.selectedIdDocumentCountryOfIssue)
              ? (_openBlock(), _createElementBlock("span", _hoisted_122, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["row col-12 text-left", {'border-2': true, 'bg-warning':!$setup.isPrivacyPolicyAgreed}])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "col-2 text-left",
              type: "checkbox",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.isPrivacyPolicyAgreed) = $event))
            }, null, 512), [
              [_vModelCheckbox, $setup.isPrivacyPolicyAgreed]
            ]),
            _hoisted_123
          ], 2)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => ($setup.UpdateOfficer && $setup.UpdateOfficer(...args))),
        disabled: $setup.isSaving
      }, _toDisplayString($setup.isSaving ? 'Saving...' : 'Save'), 9, _hoisted_124)
    ])
  ], 64))
}